import { FIELDS } from './constants';

const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },

  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 70,
  },
  // {
  //   key: 'InspectionReportTypeId',
  //   field: FIELDS.INSPECTION_REPORT_TYPE_ID,
  //   title: ' Inspection Report Type Id',
  //   label: 'InspectionReportTypeId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'InspectionReportTypeName',
    field: FIELDS.INSPECTION_REPORT_TYPE_NAME,
    title: ' Inspection Report Type Name',
    label: 'InspectionReportTypeName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'PurchaseOrderId',
  //   field: FIELDS.PURCHASE_ORDER_ID,
  //   title: ' Purchase Order Id',
  //   label: 'PurchaseOrderId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'PODate',
    field: FIELDS.PODATE,
    title: ' PODate',
    label: 'PODate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'PurchaseOrderLineId',
  //   field: FIELDS.PURCHASE_ORDER_LINE_ID,
  //   title: ' Purchase Order Line Id',
  //   label: 'PurchaseOrderLineId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'VendorId',
    field: FIELDS.VENDOR_ID,
    title: ' Vendor Id',
    label: 'VendorId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'VendorName',
    field: FIELDS.VENDOR_NAME,
    title: ' Vendor Name',
    label: 'VendorName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'VendorContactId',
    field: FIELDS.VENDOR_CONTACT_ID,
    title: ' Vendor Contact Id',
    label: 'VendorContactId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'VendorContactFullName',
    field: FIELDS.VENDOR_CONTACT_FULL_NAME,
    title: ' Vendor Contact Full Name',
    label: 'VendorContactFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesOrderLineId',
    field: FIELDS.SALES_ORDER_LINE_ID,
    title: ' Sales Order Line Id',
    label: 'SalesOrderLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CustomerId',
    field: FIELDS.CUSTOMER_ID,
    title: ' Customer Id',
    label: 'CustomerId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CustomerName',
    field: FIELDS.CUSTOMER_NAME,
    title: ' Customer Name',
    label: 'CustomerName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CustomerContactId',
    field: FIELDS.CUSTOMER_CONTACT_ID,
    title: ' Customer Contact Id',
    label: 'CustomerContactId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesPersonUserId',
    field: FIELDS.SALES_PERSON_USER_ID,
    title: ' Sales Person User Id',
    label: 'SalesPersonUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesPersonUserFullName',
    field: FIELDS.SALES_PERSON_USER_FULL_NAME,
    title: ' Sales Person User Full Name',
    label: 'SalesPersonUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QuantitySold',
    field: FIELDS.QUANTITY_SOLD,
    title: ' Quantity Sold',
    label: 'QuantitySold',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateInspected',
    field: FIELDS.DATE_INSPECTED,
    title: ' Date Inspected',
    label: 'DateInspected',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InspectedByUserId',
    field: FIELDS.INSPECTED_BY_USER_ID,
    title: ' Inspected By User Id',
    label: 'InspectedByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InspectedByUserFullName',
    field: FIELDS.INSPECTED_BY_USER_FULL_NAME,
    title: ' Inspected By User Full Name',
    label: 'InspectedByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'StatusId',
    field: FIELDS.STATUS_ID,
    title: ' Status Id',
    label: 'StatusId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryId',
    field: FIELDS.INVENTORY_ID,
    title: ' Inventory Id',
    label: 'InventoryId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartId',
    field: FIELDS.PART_ID,
    title: ' Part Id',
    label: 'PartId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartNumber',
    field: FIELDS.PART_NUMBER,
    title: ' Part Number',
    label: 'PartNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InternalPN',
    field: FIELDS.INTERNAL_PN,
    title: ' Internal PN',
    label: 'InternalPN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'NSNNumber',
    field: FIELDS.NSNNUMBER,
    title: ' NSNNumber',
    label: 'NSNNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SKU',
    field: FIELDS.SKU,
    title: ' SKU',
    label: 'SKU',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ManufacturerId',
    field: FIELDS.MANUFACTURER_ID,
    title: ' Manufacturer Id',
    label: 'ManufacturerId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'MfgName',
    field: FIELDS.MFG_NAME,
    title: ' Mfg Name',
    label: 'MfgName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryClassId',
    field: FIELDS.INVENTORY_CLASS_ID,
    title: ' Inventory Class Id',
    label: 'InventoryClassId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ClassName',
    field: FIELDS.CLASS_NAME,
    title: ' Class Name',
    label: 'ClassName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryCategoryId',
    field: FIELDS.INVENTORY_CATEGORY_ID,
    title: ' Inventory Category Id',
    label: 'InventoryCategoryId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CategoryName',
    field: FIELDS.CATEGORY_NAME,
    title: ' Category Name',
    label: 'CategoryName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PackageId',
    field: FIELDS.PACKAGE_ID,
    title: ' Package Id',
    label: 'PackageId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Package',
    field: FIELDS.PACKAGE,
    title: ' Package',
    label: 'Package',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PiecePerPkg',
    field: FIELDS.PIECE_PER_PKG,
    title: ' Piece Per Pkg',
    label: 'PiecePerPkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PhysPkg',
    field: FIELDS.PHYS_PKG,
    title: ' Phys Pkg',
    label: 'PhysPkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadFree',
    field: FIELDS.LEAD_FREE,
    title: ' Lead Free',
    label: 'LeadFree',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UoMId',
    field: FIELDS.UO_MID,
    title: ' Uo MId',
    label: 'UoMId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UOM',
    field: FIELDS.UOM,
    title: ' UOM',
    label: 'UOM',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Ordered',
    field: FIELDS.ORDERED,
    title: ' Ordered',
    label: 'Ordered',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCode',
    field: FIELDS.DATE_CODE,
    title: ' Date Code',
    label: 'DateCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LotCode',
    field: FIELDS.LOT_CODE,
    title: ' Lot Code',
    label: 'LotCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Revision',
    field: FIELDS.REVISION,
    title: ' Revision',
    label: 'Revision',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConditionId',
    field: FIELDS.CONDITION_ID,
    title: ' Condition Id',
    label: 'ConditionId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConditionName',
    field: FIELDS.CONDITION_NAME,
    title: ' Condition Name',
    label: 'ConditionName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CountryOfOriginId',
    field: FIELDS.COUNTRY_OF_ORIGIN_ID,
    title: ' Country Of Origin Id',
    label: 'CountryOfOriginId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CountryOfOriginName',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
    title: ' Country Of Origin Name',
    label: 'CountryOfOriginName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'OrderDetail_ShippingPayMethod',
    field: FIELDS.ORDER_DETAIL__SHIPPING_PAY_METHOD,
    title: ' Order Detail_ Shipping Pay Method',
    label: 'OrderDetail_ShippingPayMethod',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'OrderDetail_CODAmount',
    field: FIELDS.ORDER_DETAIL__CODAMOUNT,
    title: ' Order Detail_ CODAmount',
    label: 'OrderDetail_CODAmount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ProductDetails_Received',
    field: FIELDS.PRODUCT_DETAILS__RECEIVED,
    title: ' Product Details_ Received',
    label: 'ProductDetails_Received',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ProductDetails_Stock',
    field: FIELDS.PRODUCT_DETAILS__STOCK,
    title: ' Product Details_ Stock',
    label: 'ProductDetails_Stock',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ProductDetails_Other',
    field: FIELDS.PRODUCT_DETAILS__OTHER,
    title: ' Product Details_ Other',
    label: 'ProductDetails_Other',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ProductDetails_Marking',
    field: FIELDS.PRODUCT_DETAILS__MARKING,
    title: ' Product Details_ Marking',
    label: 'ProductDetails_Marking',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ProductDetails_Location',
    field: FIELDS.PRODUCT_DETAILS__LOCATION,
    title: ' Product Details_ Location',
    label: 'ProductDetails_Location',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ProductDetails_Breakdown',
    field: FIELDS.PRODUCT_DETAILS__BREAKDOWN,
    title: ' Product Details_ Breakdown',
    label: 'ProductDetails_Breakdown',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShipmentDetails_NumberBoxes',
    field: FIELDS.SHIPMENT_DETAILS__NUMBER_BOXES,
    title: ' Shipment Details_ Number Boxes',
    label: 'ShipmentDetails_NumberBoxes',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShipmentDetails_Condition',
    field: FIELDS.SHIPMENT_DETAILS__CONDITION,
    title: ' Shipment Details_ Condition',
    label: 'ShipmentDetails_Condition',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShipmentDetails_ShippedIn',
    field: FIELDS.SHIPMENT_DETAILS__SHIPPED_IN,
    title: ' Shipment Details_ Shipped In',
    label: 'ShipmentDetails_ShippedIn',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShipmentDetails_ShippedInOther',
    field: FIELDS.SHIPMENT_DETAILS__SHIPPED_IN_OTHER,
    title: ' Shipment Details_ Shipped In Other',
    label: 'ShipmentDetails_ShippedInOther',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShipmentDetails_Damaged',
    field: FIELDS.SHIPMENT_DETAILS__DAMAGED,
    title: ' Shipment Details_ Damaged',
    label: 'ShipmentDetails_Damaged',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShipmentDetails_Notes',
    field: FIELDS.SHIPMENT_DETAILS__NOTES,
    title: ' Shipment Details_ Notes',
    label: 'ShipmentDetails_Notes',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_OriginalPackaging',
    field: FIELDS.PACKAGING__ORIGINAL_PACKAGING,
    title: ' Packaging_ Original Packaging',
    label: 'Packaging_OriginalPackaging',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_SealedBags',
    field: FIELDS.PACKAGING__SEALED_BAGS,
    title: ' Packaging_ Sealed Bags',
    label: 'Packaging_SealedBags',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_FactoryVacuumBags',
    field: FIELDS.PACKAGING__FACTORY_VACUUM_BAGS,
    title: ' Packaging_ Factory Vacuum Bags',
    label: 'Packaging_FactoryVacuumBags',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_FactoryLabel',
    field: FIELDS.PACKAGING__FACTORY_LABEL,
    title: ' Packaging_ Factory Label',
    label: 'Packaging_FactoryLabel',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_HolesInBag',
    field: FIELDS.PACKAGING__HOLES_IN_BAG,
    title: ' Packaging_ Holes In Bag',
    label: 'Packaging_HolesInBag',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_PackageInGoodCond',
    field: FIELDS.PACKAGING__PACKAGE_IN_GOOD_COND,
    title: ' Packaging_ Package In Good Cond',
    label: 'Packaging_PackageInGoodCond',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_SurfaceSanding',
    field: FIELDS.PACKAGING__SURFACE_SANDING,
    title: ' Packaging_ Surface Sanding',
    label: 'Packaging_SurfaceSanding',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_ClearPN',
    field: FIELDS.PACKAGING__CLEAR_PN,
    title: ' Packaging_ Clear PN',
    label: 'Packaging_ClearPN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_SamePN',
    field: FIELDS.PACKAGING__SAME_PN,
    title: ' Packaging_ Same PN',
    label: 'Packaging_SamePN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Packaging_MarkedOrPrinted',
    field: FIELDS.PACKAGING__MARKED_OR_PRINTED,
    title: ' Packaging_ Marked Or Printed',
    label: 'Packaging_MarkedOrPrinted',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_MagInspect',
    field: FIELDS.SURFACE__MAG_INSPECT,
    title: ' Surface_ Mag Inspect',
    label: 'Surface_MagInspect',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_TestDots',
    field: FIELDS.SURFACE__TEST_DOTS,
    title: ' Surface_ Test Dots',
    label: 'Surface_TestDots',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_VisibleDirt',
    field: FIELDS.SURFACE__VISIBLE_DIRT,
    title: ' Surface_ Visible Dirt',
    label: 'Surface_VisibleDirt',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_VisibleDust',
    field: FIELDS.SURFACE__VISIBLE_DUST,
    title: ' Surface_ Visible Dust',
    label: 'Surface_VisibleDust',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_ImproperHandling',
    field: FIELDS.SURFACE__IMPROPER_HANDLING,
    title: ' Surface_ Improper Handling',
    label: 'Surface_ImproperHandling',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_ConsistentDCLC',
    field: FIELDS.SURFACE__CONSISTENT_DCLC,
    title: ' Surface_ Consistent DCLC',
    label: 'Surface_ConsistentDCLC',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_SameOrigin',
    field: FIELDS.SURFACE__SAME_ORIGIN,
    title: ' Surface_ Same Origin',
    label: 'Surface_SameOrigin',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_ClearMfrLogo',
    field: FIELDS.SURFACE__CLEAR_MFR_LOGO,
    title: ' Surface_ Clear Mfr Logo',
    label: 'Surface_ClearMfrLogo',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_CracksScratch',
    field: FIELDS.SURFACE__CRACKS_SCRATCH,
    title: ' Surface_ Cracks Scratch',
    label: 'Surface_CracksScratch',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_SameSurfaces',
    field: FIELDS.SURFACE__SAME_SURFACES,
    title: ' Surface_ Same Surfaces',
    label: 'Surface_SameSurfaces',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_TopBottomMarkings',
    field: FIELDS.SURFACE__TOP_BOTTOM_MARKINGS,
    title: ' Surface_ Top Bottom Markings',
    label: 'Surface_TopBottomMarkings',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_SamePinIndicator',
    field: FIELDS.SURFACE__SAME_PIN_INDICATOR,
    title: ' Surface_ Same Pin Indicator',
    label: 'Surface_SamePinIndicator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Surface_PhotosTaken',
    field: FIELDS.SURFACE__PHOTOS_TAKEN,
    title: ' Surface_ Photos Taken',
    label: 'Surface_PhotosTaken',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadVerification_StraightLeads',
    field: FIELDS.LEAD_VERIFICATION__STRAIGHT_LEADS,
    title: ' Lead Verification_ Straight Leads',
    label: 'LeadVerification_StraightLeads',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadVerification_UsedLeads',
    field: FIELDS.LEAD_VERIFICATION__USED_LEADS,
    title: ' Lead Verification_ Used Leads',
    label: 'LeadVerification_UsedLeads',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadVerification_DirtyLeads',
    field: FIELDS.LEAD_VERIFICATION__DIRTY_LEADS,
    title: ' Lead Verification_ Dirty Leads',
    label: 'LeadVerification_DirtyLeads',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadVerification_PinDamage',
    field: FIELDS.LEAD_VERIFICATION__PIN_DAMAGE,
    title: ' Lead Verification_ Pin Damage',
    label: 'LeadVerification_PinDamage',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadVerification_VisibleSolder',
    field: FIELDS.LEAD_VERIFICATION__VISIBLE_SOLDER,
    title: ' Lead Verification_ Visible Solder',
    label: 'LeadVerification_VisibleSolder',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadVerification_PhysicalPackage',
    field: FIELDS.LEAD_VERIFICATION__PHYSICAL_PACKAGE,
    title: ' Lead Verification_ Physical Package',
    label: 'LeadVerification_PhysicalPackage',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QCMgmt_BlankProgramCheck',
    field: FIELDS.QCMGMT__BLANK_PROGRAM_CHECK,
    title: ' QCMgmt_ Blank Program Check',
    label: 'QCMgmt_BlankProgramCheck',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QCMgmt_BPCResults',
    field: FIELDS.QCMGMT__BPCRESULTS,
    title: ' QCMgmt_ BPCResults',
    label: 'QCMgmt_BPCResults',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QCMgmt_XRay',
    field: FIELDS.QCMGMT__XRAY,
    title: ' QCMgmt_ XRay',
    label: 'QCMgmt_XRay',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QCMgmt_XRayResults',
    field: FIELDS.QCMGMT__XRAY_RESULTS,
    title: ' QCMgmt_ XRay Results',
    label: 'QCMgmt_XRayResults',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QCMgmt_ChemTest',
    field: FIELDS.QCMGMT__CHEM_TEST,
    title: ' QCMgmt_ Chem Test',
    label: 'QCMgmt_ChemTest',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QCMgmt_ChemTestResults',
    field: FIELDS.QCMGMT__CHEM_TEST_RESULTS,
    title: ' QCMgmt_ Chem Test Results',
    label: 'QCMgmt_ChemTestResults',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartAcceptance_AcceptedOrRejected',
    field: FIELDS.PART_ACCEPTANCE__ACCEPTED_OR_REJECTED,
    title: ' Part Acceptance_ Accepted Or Rejected',
    label: 'PartAcceptance_AcceptedOrRejected',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartAcceptance_QtyAccepted',
    field: FIELDS.PART_ACCEPTANCE__QTY_ACCEPTED,
    title: ' Part Acceptance_ Qty Accepted',
    label: 'PartAcceptance_QtyAccepted',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartAcceptance_QtyRejected',
    field: FIELDS.PART_ACCEPTANCE__QTY_REJECTED,
    title: ' Part Acceptance_ Qty Rejected',
    label: 'PartAcceptance_QtyRejected',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartAcceptance_Notes',
    field: FIELDS.PART_ACCEPTANCE__NOTES,
    title: ' Part Acceptance_ Notes',
    label: 'PartAcceptance_Notes',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InitialInspection_PODataMatch',
    field: FIELDS.INITIAL_INSPECTION__PODATA_MATCH,
    title: ' Initial Inspection_ POData Match',
    label: 'InitialInspection_PODataMatch',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InitialInspection_FactoryLabel',
    field: FIELDS.INITIAL_INSPECTION__FACTORY_LABEL,
    title: ' Initial Inspection_ Factory Label',
    label: 'InitialInspection_FactoryLabel',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InitialInspection_LabelLogo',
    field: FIELDS.INITIAL_INSPECTION__LABEL_LOGO,
    title: ' Initial Inspection_ Label Logo',
    label: 'InitialInspection_LabelLogo',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InitialInspection_ConsistentCodes',
    field: FIELDS.INITIAL_INSPECTION__CONSISTENT_CODES,
    title: ' Initial Inspection_ Consistent Codes',
    label: 'InitialInspection_ConsistentCodes',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InitialInspection_DCAgreement',
    field: FIELDS.INITIAL_INSPECTION__DCAGREEMENT,
    title: ' Initial Inspection_ DCAgreement',
    label: 'InitialInspection_DCAgreement',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InitialInspection_PackagingDamage',
    field: FIELDS.INITIAL_INSPECTION__PACKAGING_DAMAGE,
    title: ' Initial Inspection_ Packaging Damage',
    label: 'InitialInspection_PackagingDamage',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InitialInspection_DamageNotes',
    field: FIELDS.INITIAL_INSPECTION__DAMAGE_NOTES,
    title: ' Initial Inspection_ Damage Notes',
    label: 'InitialInspection_DamageNotes',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'GeneralCartonInspection_ProductWeight',
    field: FIELDS.GENERAL_CARTON_INSPECTION__PRODUCT_WEIGHT,
    title: ' General Carton Inspection_ Product Weight',
    label: 'GeneralCartonInspection_ProductWeight',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'GeneralCartonInspection_OuterPackageDamage',
    field: FIELDS.GENERAL_CARTON_INSPECTION__OUTER_PACKAGE_DAMAGE,
    title: ' General Carton Inspection_ Outer Package Damage',
    label: 'GeneralCartonInspection_OuterPackageDamage',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'GeneralCartonInspection_PhotoDamage',
    field: FIELDS.GENERAL_CARTON_INSPECTION__PHOTO_DAMAGE,
    title: ' General Carton Inspection_ Photo Damage',
    label: 'GeneralCartonInspection_PhotoDamage',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'GeneralCartonInspection_SealingTape',
    field: FIELDS.GENERAL_CARTON_INSPECTION__SEALING_TAPE,
    title: ' General Carton Inspection_ Sealing Tape',
    label: 'GeneralCartonInspection_SealingTape',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'GeneralCartonInspection_PackageClaim',
    field: FIELDS.GENERAL_CARTON_INSPECTION__PACKAGE_CLAIM,
    title: ' General Carton Inspection_ Package Claim',
    label: 'GeneralCartonInspection_PackageClaim',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'OuterCartonInspection_PhotoLabels',
    field: FIELDS.OUTER_CARTON_INSPECTION__PHOTO_LABELS,
    title: ' Outer Carton Inspection_ Photo Labels',
    label: 'OuterCartonInspection_PhotoLabels',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'OuterCartonInspection_OuterSealingTape',
    field: FIELDS.OUTER_CARTON_INSPECTION__OUTER_SEALING_TAPE,
    title: ' Outer Carton Inspection_ Outer Sealing Tape',
    label: 'OuterCartonInspection_OuterSealingTape',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'OuterCartonInspection_InspectLabels',
    field: FIELDS.OUTER_CARTON_INSPECTION__INSPECT_LABELS,
    title: ' Outer Carton Inspection_ Inspect Labels',
    label: 'OuterCartonInspection_InspectLabels',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'OuterCartonInspection_ReadableBarcode',
    field: FIELDS.OUTER_CARTON_INSPECTION__READABLE_BARCODE,
    title: ' Outer Carton Inspection_ Readable Barcode',
    label: 'OuterCartonInspection_ReadableBarcode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InnerContentInspection_InnerContents',
    field: FIELDS.INNER_CONTENT_INSPECTION__INNER_CONTENTS,
    title: ' Inner Content Inspection_ Inner Contents',
    label: 'InnerContentInspection_InnerContents',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InnerContentInspection_BagSeal',
    field: FIELDS.INNER_CONTENT_INSPECTION__BAG_SEAL,
    title: ' Inner Content Inspection_ Bag Seal',
    label: 'InnerContentInspection_BagSeal',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InnerContentInspection_CompareLabels',
    field: FIELDS.INNER_CONTENT_INSPECTION__COMPARE_LABELS,
    title: ' Inner Content Inspection_ Compare Labels',
    label: 'InnerContentInspection_CompareLabels',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InnerContentInspection_SealDate',
    field: FIELDS.INNER_CONTENT_INSPECTION__SEAL_DATE,
    title: ' Inner Content Inspection_ Seal Date',
    label: 'InnerContentInspection_SealDate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InnerContentInspection_MSLLevel',
    field: FIELDS.INNER_CONTENT_INSPECTION__MSLLEVEL,
    title: ' Inner Content Inspection_ MSLLevel',
    label: 'InnerContentInspection_MSLLevel',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InnerContentInspection_ESDCompliant',
    field: FIELDS.INNER_CONTENT_INSPECTION__ESDCOMPLIANT,
    title: ' Inner Content Inspection_ ESDCompliant',
    label: 'InnerContentInspection_ESDCompliant',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TrayInspection_ExpectedColor',
    field: FIELDS.TRAY_INSPECTION__EXPECTED_COLOR,
    title: ' Tray Inspection_ Expected Color',
    label: 'TrayInspection_ExpectedColor',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TrayInspection_PrePrintedMarkings',
    field: FIELDS.TRAY_INSPECTION__PRE_PRINTED_MARKINGS,
    title: ' Tray Inspection_ Pre Printed Markings',
    label: 'TrayInspection_PrePrintedMarkings',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TrayInspection_Oriented',
    field: FIELDS.TRAY_INSPECTION__ORIENTED,
    title: ' Tray Inspection_ Oriented',
    label: 'TrayInspection_Oriented',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TrayInspection_TopTray',
    field: FIELDS.TRAY_INSPECTION__TOP_TRAY,
    title: ' Tray Inspection_ Top Tray',
    label: 'TrayInspection_TopTray',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TrayInspection_AntiStaticCover',
    field: FIELDS.TRAY_INSPECTION__ANTI_STATIC_COVER,
    title: ' Tray Inspection_ Anti Static Cover',
    label: 'TrayInspection_AntiStaticCover',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TrayInspection_ChipOrientation',
    field: FIELDS.TRAY_INSPECTION__CHIP_ORIENTATION,
    title: ' Tray Inspection_ Chip Orientation',
    label: 'TrayInspection_ChipOrientation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TubeInspection_TubeDirection',
    field: FIELDS.TUBE_INSPECTION__TUBE_DIRECTION,
    title: ' Tube Inspection_ Tube Direction',
    label: 'TubeInspection_TubeDirection',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TubeInspection_ImprintedLogo',
    field: FIELDS.TUBE_INSPECTION__IMPRINTED_LOGO,
    title: ' Tube Inspection_ Imprinted Logo',
    label: 'TubeInspection_ImprintedLogo',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TubeInspection_TubeCondition',
    field: FIELDS.TUBE_INSPECTION__TUBE_CONDITION,
    title: ' Tube Inspection_ Tube Condition',
    label: 'TubeInspection_TubeCondition',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TubeInspection_TubeQty',
    field: FIELDS.TUBE_INSPECTION__TUBE_QTY,
    title: ' Tube Inspection_ Tube Qty',
    label: 'TubeInspection_TubeQty',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TubeInspection_TubeStoppers',
    field: FIELDS.TUBE_INSPECTION__TUBE_STOPPERS,
    title: ' Tube Inspection_ Tube Stoppers',
    label: 'TubeInspection_TubeStoppers',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReelInspection_Labels',
    field: FIELDS.REEL_INSPECTION__LABELS,
    title: ' Reel Inspection_ Labels',
    label: 'ReelInspection_Labels',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReelInspection_Size',
    field: FIELDS.REEL_INSPECTION__SIZE,
    title: ' Reel Inspection_ Size',
    label: 'ReelInspection_Size',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReelInspection_LeaderTape',
    field: FIELDS.REEL_INSPECTION__LEADER_TAPE,
    title: ' Reel Inspection_ Leader Tape',
    label: 'ReelInspection_LeaderTape',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReelInspection_Count',
    field: FIELDS.REEL_INSPECTION__COUNT,
    title: ' Reel Inspection_ Count',
    label: 'ReelInspection_Count',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReelInspection_Orientation',
    field: FIELDS.REEL_INSPECTION__ORIENTATION,
    title: ' Reel Inspection_ Orientation',
    label: 'ReelInspection_Orientation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ReelInspection_Damage',
    field: FIELDS.REEL_INSPECTION__DAMAGE,
    title: ' Reel Inspection_ Damage',
    label: 'ReelInspection_Damage',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'BulkInspection_Count',
    field: FIELDS.BULK_INSPECTION__COUNT,
    title: ' Bulk Inspection_ Count',
    label: 'BulkInspection_Count',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'BulkInspection_Bag',
    field: FIELDS.BULK_INSPECTION__BAG,
    title: ' Bulk Inspection_ Bag',
    label: 'BulkInspection_Bag',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'BulkInspection_BagMarkings',
    field: FIELDS.BULK_INSPECTION__BAG_MARKINGS,
    title: ' Bulk Inspection_ Bag Markings',
    label: 'BulkInspection_BagMarkings',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'BulkInspection_DateCodes',
    field: FIELDS.BULK_INSPECTION__DATE_CODES,
    title: ' Bulk Inspection_ Date Codes',
    label: 'BulkInspection_DateCodes',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Logo',
    field: FIELDS.DETAIL_INSPECTION__LOGO,
    title: ' Detail Inspection_ Logo',
    label: 'DetailInspection_Logo',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Markings',
    field: FIELDS.DETAIL_INSPECTION__MARKINGS,
    title: ' Detail Inspection_ Markings',
    label: 'DetailInspection_Markings',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_MarkingTopBottom',
    field: FIELDS.DETAIL_INSPECTION__MARKING_TOP_BOTTOM,
    title: ' Detail Inspection_ Marking Top Bottom',
    label: 'DetailInspection_MarkingTopBottom',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_LaserMarks',
    field: FIELDS.DETAIL_INSPECTION__LASER_MARKS,
    title: ' Detail Inspection_ Laser Marks',
    label: 'DetailInspection_LaserMarks',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Size',
    field: FIELDS.DETAIL_INSPECTION__SIZE,
    title: ' Detail Inspection_ Size',
    label: 'DetailInspection_Size',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Burns',
    field: FIELDS.DETAIL_INSPECTION__BURNS,
    title: ' Detail Inspection_ Burns',
    label: 'DetailInspection_Burns',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Dots',
    field: FIELDS.DETAIL_INSPECTION__DOTS,
    title: ' Detail Inspection_ Dots',
    label: 'DetailInspection_Dots',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_FLux',
    field: FIELDS.DETAIL_INSPECTION__FLUX,
    title: ' Detail Inspection_ FLux',
    label: 'DetailInspection_FLux',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Cracks',
    field: FIELDS.DETAIL_INSPECTION__CRACKS,
    title: ' Detail Inspection_ Cracks',
    label: 'DetailInspection_Cracks',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_PinCount',
    field: FIELDS.DETAIL_INSPECTION__PIN_COUNT,
    title: ' Detail Inspection_ Pin Count',
    label: 'DetailInspection_PinCount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Terminal',
    field: FIELDS.DETAIL_INSPECTION__TERMINAL,
    title: ' Detail Inspection_ Terminal',
    label: 'DetailInspection_Terminal',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Leads',
    field: FIELDS.DETAIL_INSPECTION__LEADS,
    title: ' Detail Inspection_ Leads',
    label: 'DetailInspection_Leads',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Oxidation',
    field: FIELDS.DETAIL_INSPECTION__OXIDATION,
    title: ' Detail Inspection_ Oxidation',
    label: 'DetailInspection_Oxidation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_SuspectPart',
    field: FIELDS.DETAIL_INSPECTION__SUSPECT_PART,
    title: ' Detail Inspection_ Suspect Part',
    label: 'DetailInspection_SuspectPart',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Scratches',
    field: FIELDS.DETAIL_INSPECTION__SCRATCHES,
    title: ' Detail Inspection_ Scratches',
    label: 'DetailInspection_Scratches',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_BGA',
    field: FIELDS.DETAIL_INSPECTION__BGA,
    title: ' Detail Inspection_ BGA',
    label: 'DetailInspection_BGA',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DetailInspection_Photo',
    field: FIELDS.DETAIL_INSPECTION__PHOTO,
    title: ' Detail Inspection_ Photo',
    label: 'DetailInspection_Photo',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SolventInspection_MarkingTestDetail',
    field: FIELDS.SOLVENT_INSPECTION__MARKING_TEST_DETAIL,
    title: ' Solvent Inspection_ Marking Test Detail',
    label: 'SolventInspection_MarkingTestDetail',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SolventInspection_SurfaceTestDetail',
    field: FIELDS.SOLVENT_INSPECTION__SURFACE_TEST_DETAIL,
    title: ' Solvent Inspection_ Surface Test Detail',
    label: 'SolventInspection_SurfaceTestDetail',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SolventInspection_ScrapeTestDetail',
    field: FIELDS.SOLVENT_INSPECTION__SCRAPE_TEST_DETAIL,
    title: ' Solvent Inspection_ Scrape Test Detail',
    label: 'SolventInspection_ScrapeTestDetail',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'MechanicalInspection_Tolerance',
    field: FIELDS.MECHANICAL_INSPECTION__TOLERANCE,
    title: ' Mechanical Inspection_ Tolerance',
    label: 'MechanicalInspection_Tolerance',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'MechanicalInspection_Dimensions',
    field: FIELDS.MECHANICAL_INSPECTION__DIMENSIONS,
    title: ' Mechanical Inspection_ Dimensions',
    label: 'MechanicalInspection_Dimensions',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'MechanicalInspection_ThicknessVariation',
    field: FIELDS.MECHANICAL_INSPECTION__THICKNESS_VARIATION,
    title: ' Mechanical Inspection_ Thickness Variation',
    label: 'MechanicalInspection_ThicknessVariation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
